import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 9.6V7.5L7.5 3L3 7.5V9.6L6.75 5.85V19.5H8.25V5.85L12 9.6ZM21 16.5V14.4L17.25 18.15V4.5H15.75V18.15L12 14.4V16.5L16.5 21L21 16.5Z",
		fill: "currentColor"
	})
});
export default SvgSort;
